/* eslint-disable import/prefer-default-export */
import { orderBy } from 'lodash';

export const getModelsForTypeMixin = {
  methods: {
    getModelsForType(type, store, sortDirection) {
      let direction = sortDirection;
      const deviceTypes = store.state.devices.types;
      const deviceModels = store.state.devices.models;
      if (!direction) direction = 'asc';

      // check for empty list
      if (!deviceTypes) return []; 
      // find matching DeviceType
      const deviceTypeMatch = deviceTypes.find(t => t.shortcode == type);      
      // unable to match device type, return empty array
      if (!deviceTypeMatch) return [];
      // return list of available device models for type
      return orderBy(deviceModels.filter(m => m.deviceTypeId == deviceTypeMatch.id), ['name'], [direction]);
    }
  }
}
